import { yupResolver } from "@hookform/resolvers/yup";
import {
	FieldValues,
	useForm as useFormMain,
	UseFormProps,
	SubmitHandler,
	SubmitErrorHandler,
	UseFormReturn,
} from "react-hook-form";
import { ObjectSchema } from "yup";

export interface IFormReturn<Values extends FieldValues = FieldValues>
	extends UseFormReturn<Values> {
	submit: () => void;
	schema: ObjectSchema<any>;
}

interface IProps<Values extends FieldValues> extends UseFormProps<Values> {
	schema: ObjectSchema<any>;
	onSuccess: SubmitHandler<Values>;
	onError?: SubmitErrorHandler<Values>;
}

export const useForm = <Values extends FieldValues = FieldValues>({
	schema,
	onSuccess,
	onError,
	defaultValues,
	...props
}: IProps<Values>): IFormReturn<Values> => {
	const resolver = yupResolver(schema);
	const methods = useFormMain<Values>({
		...props,
		resolver,
		defaultValues: { ...schema.getDefault(), ...defaultValues },
	});

	const { handleSubmit } = methods;

	const submit = handleSubmit(onSuccess, onError);

	return { submit, schema, ...methods };
};
